import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, map, mergeMap, of, take, takeUntil } from 'rxjs';
import { qrCodesActions } from '../actions/qr-codes.actions';
import { selectPending } from '../selectors/qr-codes.selector';
import { HttpService } from '../services/http.service';

const MAX_CONCURRENT_LOADS = 3;

@Injectable()
export class QrCodesEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly httpService = inject(HttpService);

    // pending (kept by the reducer) is the queue authority: a url missing from it when its slot frees up — cached, deduped, or canceled — is skipped, and Cancel Loading aborts the in-flight requests.
    loadQrCode$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(qrCodesActions.loadQrCode),
            mergeMap(({ url }) => {
                return this.store.select(selectPending).pipe(
                    take(1),
                    mergeMap((pending) => {
                        if (!pending.includes(url)) {
                            return EMPTY;
                        }

                        return this.httpService.getQrCode(url).pipe(
                            map((svg) => qrCodesActions.loadQrCodeSuccess({ url, svg })),
                            catchError((error: HttpErrorResponse) => of(qrCodesActions.loadQrCodeError({ url, code: error.status }))),
                            takeUntil(this.actions$.pipe(ofType(qrCodesActions.cancelLoading))),
                        );
                    }),
                );
            }, MAX_CONCURRENT_LOADS),
        );
    });
}
